// @ts-nocheck
import { apiRequest } from "../../../services/apiService";
import {
  PREBOOK_CONTRACTORS_REQUEST,
  PREBOOK_CONTRACTORS_FAILURE,
  PREBOOK_CONTRACTORS_SUCCESS,
  FETCH_PREBOOK_CONTRACTORS_REQUEST,
  FETCH_PREBOOK_CONTRACTORS_SUCCESS,
  FETCH_PREBOOK_CONTRACTORS_FAILURE,
  CHECK_FOR_HOLDDOWN_DATES_REQUEST,
  CHECK_FOR_HOLDDOWN_DATES_SUCCESS,
  CHECK_FOR_HOLDDOWN_DATES_FAILURE,
} from "../../constants/event/prebook";

// prebook contractor request action
export const createPrebookingAction = ({
  payload,
  successCallback,
  failureCallback,
}) => {
  return async (dispatch) => {
    dispatch({ type: PREBOOK_CONTRACTORS_REQUEST });
    const { response, error } = await apiRequest({
      method: "POST",
      url: "bookContractors",
      data: payload?.data,
      isToken: true,
    });

    if (response?.status === 200) {
      dispatch({
        type: PREBOOK_CONTRACTORS_SUCCESS,
        payload: response?.data?.data,
      });
      if (successCallback) successCallback(response?.data);
    } else if (response?.status !== 200 || error) {
      dispatch({ type: PREBOOK_CONTRACTORS_FAILURE });
      if (failureCallback) failureCallback(error?.response?.data?.message);
    }
  };
};

// fetch prebook contractors
export const fetchPrebookContractorsAction = ({
  payload,
  successCallback,
  failureCallback,
}) => {
  return async (dispatch) => {
    dispatch({
      type: FETCH_PREBOOK_CONTRACTORS_REQUEST,
      payload: payload?.params?.search,
    });
    const { response, error } = await apiRequest({
      method: "GET",
      url: "getGroupedContractors",
      params: payload?.params,
      isToken: true,
    });

    if (response?.status === 200) {
      dispatch({
        type: FETCH_PREBOOK_CONTRACTORS_SUCCESS,
        payload: response?.data,
      });
      if (successCallback) successCallback();
    } else if (response?.status !== 200 || error) {
      dispatch({ type: FETCH_PREBOOK_CONTRACTORS_FAILURE });
      if (failureCallback) failureCallback();
    }
  };
};

// check holddown dates
export const checkForHoldDownAction = ({
  payload,
  successCallback,
  failureCallback,
}) => {
  return async (dispatch) => {
    dispatch({ type: CHECK_FOR_HOLDDOWN_DATES_REQUEST });
    const { response, error } = await apiRequest({
      method: "POST",
      url: "checkScheduledBookedDates",
      data: payload?.data,
      isToken: true,
    });

    if (response?.status === 200) {
      dispatch({
        type: CHECK_FOR_HOLDDOWN_DATES_SUCCESS,
        payload: response?.data?.data,
      });
      if (successCallback) successCallback(response?.data?.data);
    } else if (response?.status !== 200 || error) {
      dispatch({ type: CHECK_FOR_HOLDDOWN_DATES_FAILURE });
      if (failureCallback) failureCallback(error?.response?.data?.message);
    }
  };
};